import { PartnerPlatform } from '../PartnerPlatform/PartnerPlatform';

export interface ProductIdentifiers {
  productID: number;
  optionValueID?: string;
  barcode?: string;
  sku?: string;
  hepsiburadaSKU?: string;
}

export interface ProductIdentifierUpdate {
  productID: number;
  optionValueID?: string;
  value: string;
}

export const transformProductIdentifierUpdate = (
  update: ProductIdentifierUpdate,
  platform: PartnerPlatform,
): ProductIdentifiers => {
  const base = {
    productID: update.productID,
    optionValueID: update.optionValueID,
  };

  switch (platform) {
    case 'hepsiburada':
      return { ...base, hepsiburadaSKU: update.value };
    case 'n11':
      return { ...base, sku: update.value };
    default:
      return { ...base, barcode: update.value };
  }
};

export const productIdentifiersToUpdateRequest = (
  identifiers: ProductIdentifiers,
) => ({
  product_id: identifiers.productID,
  option_value_id: identifiers.optionValueID,
  barcode: identifiers.barcode,
  sku: identifiers.sku,
  hepsiburada_sku: identifiers.hepsiburadaSKU,
});
